/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrdinamentoScolastico } from './ordinamento-scolastico';


export interface TipoPraticaIstitutoPlessoCreationForm { 
    nome: string;
    ordinamento?: OrdinamentoScolastico;
    codice_meccanografico?: string;
    indirizzo_via?: string;
    civico?: string;
    indirizzo_studio?: string;
    attivo?: boolean;
}



